import { FC, ReactNode } from 'react'

import { Nullable } from 'cng-common/models/utils'

import { Marker } from './components/marker/Marker'

import styles from './Percent.module.scss'

interface IPercent {
  value?: Nullable<number>
  shouldConvertValue?: boolean
  withMarker?: boolean
  signSlot?: ReactNode
}

export const Percent: FC<IPercent> = ({
  value,
  shouldConvertValue = true,
  withMarker = false,
  signSlot,
}) => {
  if (value === null || value === undefined) {
    return <>-</>
  }

  const percent = shouldConvertValue ? value * 100 : value

  return (
    <div className={styles.perfContainer}>
      {withMarker && (
        <div className={styles.markerWrapper}>
          <Marker value={percent} />
        </div>
      )}
      <div className={styles.centeredContent}>
        {signSlot}
        {percent.toFixed(1)}%
      </div>
    </div>
  )
}
